import Vue from 'vue'
import App from './App.vue'
import vuetify from './plugins/vuetify'
import router from './router'

Vue.config.productionTip = false
Vue.prototype.$liff = window.liff
Vue.prototype.$Spin2WinWheel = window.Spin2WinWheel
Vue.prototype.$liffId_VLinked = "1653760842-wLO4yVeY"
Vue.prototype.$liffId_VGroup = "1654571534-PeGYNq1q"
// Vue.prototype.$apiUrl = "http://localhost:5001/betask-loyalty/asia-northeast1/"
Vue.prototype.$apiUrl = "https://asia-northeast1-betask-loyalty.cloudfunctions.net/"

new Vue({
  vuetify,
  router,
  render: h => h(App)
}).$mount('#app')
